module.exports = __webpack_public_path__ + "img/system.19a4c274.svg";